export const FURNISHED = 1;
export const SEMI_FURNISHED = 2;

const FURNISHED_BADGE_TITLES: Record<number, string> = {
  [FURNISHED]: "Mobiliado",
  [SEMI_FURNISHED]: "Semimobiliado",
};

export function getFurnishedBadgeTitle(
  isFurnished: number | boolean | null | undefined
): string | null {
  const value = Number(isFurnished);

  return FURNISHED_BADGE_TITLES[value] ?? null;
}
